
import { defineComponent } from 'vue'
import { iDataItem } from './SchedulationAgenda'
import schedulationAgendaDescriptor from './SchedulationAgendaDescriptor.json'
import Dialog from 'primevue/dialog'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import { FilterOperator } from 'primevue/api'
import { filterDefault } from '@/helpers/commons/filterHelper'

export default defineComponent({
    name: 'configuration-management-dialog',
    components: { Dialog, DataTable, Column },
    props: {
        model: Object,
        title: String,
        itemList: Array
    },
    emits: ['close', 'changed'],

    data() {
        return {
            schedulationAgendaDescriptor: schedulationAgendaDescriptor,
            selectedItem: null as iDataItem | null,
            dirty: false,
            options: [true, false],
            loading: false,
            columns: schedulationAgendaDescriptor.columns,
            filters: {
                global: [filterDefault],
                name: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                },
                description: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                }
            } as Object
        }
    },
    mounted() {
        if (this.model) {
            this.selectedItem = { ...this.model } as iDataItem
        }
    },
    computed: {
        buttonDisabled(): any {
            return false
        }
    },
    watch: {
        model() {
            this.selectedItem = { ...this.model } as iDataItem
        }
    },
    methods: {
        closeTemplate() {
            this.$emit('close')
        },
        selectRow(event) {
            if (event) {
                this.selectedItem = event.data
            }
        },
        handleSubmit() {
            this.$emit('changed', this.selectedItem)
        }
    }
})
